import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ResourceFilters = ({ filters, onFilterChange, onReset, categories, activeTab }) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'assigned', label: 'Assigned' },
    { value: 'available', label: 'Available' },
    { value: 'maintenance', label: 'Maintenance' },
  ];

  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    ...categories?.map(cat => ({ value: cat?.id, label: cat?.name }))
  ];

  const usageTimelineOptions = [
    { value: 'all', label: 'All Usage Timelines' },
    { value: 'within-30', label: 'In Use Within 30 Days' },
    { value: 'within-60', label: 'In Use Within 60 Days' },
    { value: 'within-90', label: 'In Use Within 90 Days' },
    { value: 'beyond-90', label: 'In Use Beyond 90 Days' }
  ];

  const isGanttView = activeTab === 'gantt';

  const hasActiveFilters =
    filters?.search ||
    filters?.category !== 'all' ||
    filters?.status !== 'all' ||
    (isGanttView && filters?.usageTimeline !== 'all');

  return (
    <div className="bg-card rounded-lg border border-border px-3 py-2.5">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-medium text-foreground shrink-0 mr-1">Filter Resources</span>

        <div className="flex-1 min-w-[140px] max-w-xs">
          <Input
            type="search"
            placeholder="Search resources..."
            value={filters?.search}
            onChange={(e) => onFilterChange({ ...filters, search: e?.target?.value })}
            className="h-8 text-sm"
          />
        </div>

        <div className="min-w-[150px]">
          <Select
            options={categoryOptions}
            value={filters?.category}
            onChange={(value) => onFilterChange({ ...filters, category: value })}
            placeholder="Category"
            className="h-8 text-sm"
          />
        </div>

        <div className="min-w-[140px]">
          <Select
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => onFilterChange({ ...filters, status: value })}
            placeholder="Status"
            className="h-8 text-sm"
          />
        </div>

        {isGanttView && (
          <div className="min-w-[170px]">
            <Select
              options={usageTimelineOptions}
              value={filters?.usageTimeline || 'all'}
              onChange={(value) => onFilterChange({ ...filters, usageTimeline: value })}
              placeholder="Usage Timeline"
              className="h-8 text-sm"
            />
          </div>
        )}

        {hasActiveFilters && (
          <button
            onClick={onReset}
            className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors shrink-0 px-2 py-1 rounded hover:bg-muted/50"
          >
            <Icon name="X" size={12} />
            Clear
          </button>
        )}
      </div>
    </div>
  );
};

export default ResourceFilters;